import React from 'react';
import './ItsMozartKPuzzle.css';

const VIDEO_URL = 'https://firebasestorage.googleapis.com/v0/b/danhunt-380e3.firebasestorage.app/o/puzzles%2Fitsmozartk%2Fitsmozartkvideo-cb70ed82.mp4?alt=media';

function ItsMozartKPuzzle() {
  return (
    <div className="mozart-puzzle">
      <div className="mozart-video-container">
        <video 
          controls 
          className="mozart-video"
          preload="metadata"
        >
          <source src={VIDEO_URL} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}

export default ItsMozartKPuzzle;
